import { useContext, useState } from "react";
import { LINK, SELECTED_PATIENT, PARTICIPANT_LINK_FAIL} from "../../util/const";
import { Participant } from "../../types/participant";
import { PatientContext } from "../ActivePatients";
import { FormatDateForDisplay } from "../../util/data-utils";
import OrphanParticipants from "../OrphanParticipants";
import LinkingHelper from "../../Helpers/LinkingHelper";

export type LinkingProps = {
  toggleDisplay: (didSave: boolean) => void;
  participantChanged?: (p: Participant) => void;
}

const LinkPatient = (props:LinkingProps) =>
{
  const context = useContext(PatientContext);

  const [error, setError] = useState("");
  
  const onLinkOrCancel = (subject?: Participant) => {

    if(subject) 
    {
      LinkingHelper(context.patient, subject).then((value) => {
        if(value)
        {
          if(props.participantChanged !== undefined)
            props.participantChanged(subject);
          else
            props.toggleDisplay(true);
        }
        else
          setError(PARTICIPANT_LINK_FAIL); 
      });
    }
  }

  return (
    <>
    {SELECTED_PATIENT}: {context.patient.givenNames} {context.patient.familyName} | DOB: {FormatDateForDisplay(context.patient.birthDate)} | Email: {context.patient.email}
    <hr />
    <OrphanParticipants actionHeaderText={""} actionText={LINK} parentCallback={onLinkOrCancel} patient={context.patient}/>
    <div>{error}</div>
    </>
  )
}

export default LinkPatient;